import type { FeatureFlags } from '@features/flags.graphql'

/**
 * This is our default mock we will fallback to, whenever no connection could be established to launchdarkly.
 */
export const FeatureFlagsMock: FeatureFlags = {
  analyticsEnabled: {
    datadog: false,
    segment: false,
  },
  aptosEnabled: true,
  faucetEnabled: true,
  faucetMaintenanceModeEnabled: {
    global: false,
    affectedChains: [],
  },
  solanaSupportEnabled: true,
  contentApiEnabled: true,
  baseEurcEnabled: true,
  recaptchaEnabled: false,
  reCaptchaThreshold: 0.3,
  apiReferencePageEnabled: true,
  migrationEnabled: true,
  suiEnabled: true,
  uniEnabled: true,
  xrpEnabled: true,
  hyperevmEnabled: true,
  codexEnabled: true,
  coreEnabled: true,
  inkEnabled: true,
  lineaEnabled: true,
  monadEnabled: true,
  plumeEnabled: true,
  seiEnabled: true,
  sonicEnabled: true,
  worldchainEnabled: true,
  xdcEnabled: true,
  unifiedReferenceEnabled: true,
  liquidityWizardEnabled: true,
  sdkAndSampleOverviewEnabled: true,
  faucetFaqEnabled: true,
  faucetEOAWalletEnabled: true,
  sdkExplorerEnabled: true,
  aiChatbotEnabled: false,
  aiChatbotGradualRollout: true,
  aiChatbotInternalQA: false,
  cpnWalletValidatorEnabled: false,
}
